import React, { Component } from "react";
import MapComponent from "../MapComponent/MapComponent";
import ToggleBox from "../ToggleBox/ToggleBox";
import { Marker, Polyline } from "react-google-maps";
import {
	getSchools,
	getBusRoutes,
	getBusStops,
	getParkAndRides,
	getHealthcare,
	getGroceryStores,
	getIcons,
	getParks,
	getWorship,
	getMarinas,
	getDogParks,
	getRestaurants,
	getSports,
	getHouses,
	getLibraries,
	getTransportation,
	getEntertainment,
	getChildcare,
	getTrails,
	getCulture
} from "../../../../actions/Map/dataActions.js";
import { setTogglesExternal } from "../../../../actions/Map/surveyActions";
import { toggleMarker } from "../../../../actions/Map/mapActions";
import { connect } from "react-redux";
import styles from "./MapBox.scss";
import ToggleTypesBox from "../ToggleTypes/ToggleTypesBox";
import Info from "../Info/Info";
import SearchBox from "../SearchBox/SearchBox";
import NeighbourhoodName from "../NeighbourhoodName/NeighbourhoodName";

const flattenArray = arrayOfArrays => {
	var newArr = [];
	for (let i = 0; i < arrayOfArrays.length; i++) {
		for (let y = 0; y < arrayOfArrays[i].length; y++) {
			newArr = newArr.concat(arrayOfArrays[i][y]);
		}
	}
	return newArr;
};

class MapBox extends Component {
	constructor(props) {
		super(props);
		this.state = {
			markersArray: [],
			types: {
				SCHOOLS: [],
				HEALTHCARE: [],
				SPORTS: [],
				HOUSES: [],
				ENTERTAINMENT: [],
				TRANSIT: [] // includes bus stops, bus routes, and park & rides
				// WORSHIP: [],
				// RESTAURANTS: [],
			},
			infoWindow: undefined,
			markersData: {
				SCHOOLS: [],
				BUSROUTES: [],
				BUSSTOPS: [],
				PARKANDRIDES: [],
				HEALTHCARE: [],
				GROCERYSTORES: [],
				PARKS: [],
				WORSHIP: [],
				MARINAS: [],
				DOGPARKS: [],
				RESTAURANTS: [],
				HOUSES: [],
				ICONS: [],
				SPORTS: [],
				LIBRARIES: [],
				TRANSPORTATION: [],
				ENTERTAINMENT: [],
				CHILDCARE: [],
				CULTURE: []
			},
			loading: true
		};
	}

	componentDidMount() {
		this.getMapData();
		//   .then(() => {
		//     setTimeout(() => { this.getExternalToggles() }, 500)
		//   }
		// ).then(() => {
		//   this.setState({ loading: false })
		// })
	}

	getExternalToggles = () => {
		let newMarkersArray = [];

		for (let t = 0; t < this.props.externalToggles.length; t++) {
			let toggle = this.props.externalToggles[t];

			if (toggle === "Hospitals") {
				let HEALTHCARE = this.state.markersData.HEALTHCARE;
				for (let i = 0; i < HEALTHCARE.length; i++) {
					let walkin = HEALTHCARE[i];
					if (walkin.type === "Hospitals") {
						// Build Walkin Marker
						let walkinMarker = this.makeMarker(
							walkin.name,
							walkin.lat,
							walkin.lng,
							"healthcare",
							<div className={styles.infoWindow}>
								<h5>{walkin.name}</h5>
								<p>Type: {walkin.type}</p>
								<p>Address: {walkin.address}</p>
							</div>
						);
						newMarkersArray = [...newMarkersArray, walkinMarker];
					}
				}
			} else if (toggle === "Long-Term Care") {
				let HEALTHCARE = this.state.markersData.HEALTHCARE;
				for (let i = 0; i < HEALTHCARE.length; i++) {
					let walkin = HEALTHCARE[i];
					if (walkin.type === "Long-Term Care") {
						// Build Walkin Marker
						let walkinMarker = this.makeMarker(
							walkin.name,
							walkin.lat,
							walkin.lng,
							"healthcare",
							<div className={styles.infoWindow}>
								<h5>{walkin.name}</h5>
								<p>Type: {walkin.type}</p>
								<p>Address: {walkin.address}</p>
							</div>
						);
						newMarkersArray = [...newMarkersArray, walkinMarker];
					}
				}
			} else {
				this.props.toggleMarker(toggle);
			}
		}
		this.setState({
			markersArray: newMarkersArray
		});
	};

	async getMapData() {
		await Promise.all([
			await getParks().then(res => {
				this.setState(
					{
						markersData: {
							...this.state.markersData,
							PARKS: res.data
						}
					},
					() => {
						return Promise.resolve();
					}
				);
			}),

			await getSchools().then(res => {
				var types = [];
				for (var i = 0; i < res.data.length; i++) {
					if (!types.includes(res.data[i].type)) {
						types = [...types, res.data[i].type];
					}
				}
				this.setState(
					{
						markersData: {
							...this.state.markersData,
							SCHOOLS: res.data
						},
						types: { ...this.state.types, SCHOOLS: types }
					},
					() => {
						return Promise.resolve();
					}
				);
			}),

			await getSports().then(res => {
				var types = [];
				for (var i = 0; i < res.data.length; i++) {
					if (!types.includes(res.data[i].type)) {
						types = [...types, res.data[i].type];
					}
				}
				this.setState(
					{
						markersData: {
							...this.state.markersData,
							SPORTS: res.data
						},
						types: { ...this.state.types, SPORTS: types }
					},
					() => {
						return Promise.resolve();
					}
				);
			}),

			await getBusRoutes().then(res => {
				this.setState(
					{
						markersData: {
							...this.state.markersData,
							BUSROUTES: res.data[0].records
						},
						types: {
							...this.state.types,
							TRANSIT: [...this.state.types.TRANSIT, "Bus Route"]
						}
					},
					() => {
						return Promise.resolve();
					}
				);
			}),

			await getHealthcare().then(res => {
				var types = [];
				for (var i = 0; i < res.data.length; i++) {
					if (!types.includes(res.data[i].type)) {
						types = [...types, res.data[i].type];
					}
				}
				this.setState(
					{
						markersData: {
							...this.state.markersData,
							HEALTHCARE: res.data
						},
						types: { ...this.state.types, HEALTHCARE: types }
					},
					() => {
						return Promise.resolve();
					}
				);
			}),

			await getGroceryStores().then(res => {
				this.setState(
					{
						markersData: {
							...this.state.markersData,
							GROCERYSTORES: res.data
						}
					},
					() => {
						return Promise.resolve();
					}
				);
			}),

			await getIcons().then(res => {
				this.setState(
					{
						markersData: {
							...this.state.markersData,
							ICONS: res.data
						}
					},
					() => {
						return Promise.resolve();
					}
				);
			}),

			await getBusStops().then(res => {
				this.setState(
					{
						markersData: {
							...this.state.markersData,
							BUSSTOPS: res.data[0].records
						},
						types: {
							...this.state.types,
							TRANSIT: [...this.state.types.TRANSIT, "Bus Stop"]
						}
					},
					() => {
						return Promise.resolve();
					}
				);
			}),

			await getParkAndRides().then(res => {
				var types = [];
				for (var i = 0; i < res.data.length; i++) {
					if (!types.includes(res.data[i].type)) {
						types = [...types, res.data[i].type];
					}
				}
				this.setState(
					{
						markersData: {
							...this.state.markersData,
							PARKANDRIDES: res.data
						},
						types: {
							...this.state.types,
							TRANSIT: [...this.state.types.TRANSIT, ...types]
						}
					},
					() => {
						return Promise.resolve();
					}
				);
			}),

			await getWorship().then(res => {
				var types = [];
				for (var i = 0; i < res.data.length; i++) {
					if (!types.includes(res.data[i].type)) {
						types = [...types, res.data[i].type];
					}
				}
				this.setState(
					{
						markersData: {
							...this.state.markersData,
							WORSHIP: res.data
						},
						types: { ...this.state.types, WORSHIP: types }
					},
					() => {
						return Promise.resolve();
					}
				);
			}),

			await getMarinas().then(res => {
				this.setState(
					{
						markersData: {
							...this.state.markersData,
							MARINAS: res.data
						}
					},
					() => {
						return Promise.resolve();
					}
				);
			}),

			await getDogParks().then(res => {
				this.setState(
					{
						markersData: {
							...this.state.markersData,
							DOGPARKS: res.data
						}
					},
					() => {
						return Promise.resolve();
					}
				);
			}),

			await getRestaurants().then(res => {
				var types = [];
				for (var i = 0; i < res.data.length; i++) {
					if (!types.includes(res.data[i].type)) {
						types = [...types, res.data[i].type];
					}
				}
				this.setState(
					{
						markersData: {
							...this.state.markersData,
							RESTAURANTS: res.data
						},
						types: { ...this.state.types, RESTAURANTS: types }
					},
					() => {
						return Promise.resolve();
					}
				);
			}),

			await getHouses().then(res => {
				var types = [];
				for (var i = 0; i < res.data.length; i++) {
					if (!types.includes(res.data[i].type)) {
						types = [...types, res.data[i].type];
					}
				}
				this.setState(
					{
						markersData: {
							...this.state.markersData,
							HOUSES: res.data
						},
						types: { ...this.state.types, HOUSES: types }
					},
					() => {
						return Promise.resolve();
					}
				);
			}),

			await getLibraries().then(res => {
				this.setState(
					{
						markersData: {
							...this.state.markersData,
							LIBRARIES: res.data
						}
					},
					() => {
						return Promise.resolve();
					}
				);
			}),

			await getTransportation().then(res => {
				this.setState(
					{
						markersData: {
							...this.state.markersData,
							TRANSPORTATION: res.data
						}
					},
					() => {
						return Promise.resolve();
					}
				);
			}),

			await getEntertainment().then(res => {
				var types = [];
				for (var i = 0; i < res.data.length; i++) {
					if (!types.includes(res.data[i].type)) {
						types = [...types, res.data[i].type];
					}
				}
				this.setState(
					{
						markersData: {
							...this.state.markersData,
							ENTERTAINMENT: res.data
						},
						types: { ...this.state.types, ENTERTAINMENT: types }
					},
					() => {
						return Promise.resolve();
					}
				);
			}),

			await getChildcare().then(res => {
				this.setState(
					{
						markersData: {
							...this.state.markersData,
							CHILDCARE: res.data
						}
					},
					() => {
						return Promise.resolve();
					}
				);
			}),

			await getCulture().then(res => {
				this.setState(
					{
						markersData: {
							...this.state.markersData,
							CULTURE: res.data
						}
					},
					() => {
						return Promise.resolve();
					}
				);
			}),

			await getTrails()
				.then(res => {
					this.setState({
						markersData: {
							...this.state.markersData,
							TRAILS: res.data
						}
					});
				})
				.then(Promise.resolve())
		]).then(() => {
			this.setState({ loading: false });
		});
	}

	closeInfoWindow = () => {
		this.setState({
			infoWindow: undefined
		});
	};

	handleClick = (_lat, _lng, _info) => {
		// _info is overloaded, set to undefined unless specified
		if (this.state.infoWindow === undefined) {
			this.setState({
				infoWindow: {
					position: { lat: _lat, lng: _lng },
					info: _info
				}
			});
		} else if (
			this.state.infoWindow.position.lat !== _lat ||
			this.state.infoWindow.position.lng !== _lng
		) {
			this.setState({
				infoWindow: {
					position: { lat: _lat, lng: _lng },
					info: _info
				}
			});
		} else {
			this.setState({
				infoWindow: undefined
			});
		}
	};

	makeMarker = (name, lat, lng, type, info) => {
		let ICONS = this.state.markersData.ICONS;
		let size = 20;
		if (type === "busstop") {
			size = 8;
		}
		return (
			<Marker
				className={styles.Marker}
				name={name}
				position={{ lat: lat, lng: lng }}
				icon={{
					url: ICONS[type],
					scaledSize: new window.google.maps.Size(size, size)
				}}
				// onClick={() => this.handleClick(lat, lng, info)}
				onMouseOver={() => this.handleClick(lat, lng, info)}
			/>
		);
	};

	getExtremities(coordinatesArray) {
		const coordinates = flattenArray(coordinatesArray);
		var minLat = parseFloat(coordinates[0].lat);
		var minLng = parseFloat(coordinates[0].lng);
		var maxLat = parseFloat(coordinates[0].lat);
		var maxLng = parseFloat(coordinates[0].lng);

		for (var i = 0; i < coordinates.length; i++) {
			if (coordinates[i].lat < minLat) {
				minLat = coordinates[i].lat;
			}
			if (coordinates[i].lng < minLng) {
				minLng = coordinates[i].lng;
			}
			if (coordinates[i].lat > maxLat) {
				maxLat = parseFloat(coordinates[i].lat);
			}
			if (coordinates[i].lng > maxLng) {
				maxLng = parseFloat(coordinates[i].lng);
			}
		}
		const sw = { lat: minLat, lng: minLng };
		const ne = { lat: maxLat, lng: maxLng };
		return { sw: sw, ne: ne };
	}

	isInPolygon = (point, extremities) => {
		let latBuffer = 0.02;
		let lngBuffer = 0.03;
		if (
			extremities.sw.lat - latBuffer <= point.lat &&
			point.lat <= extremities.ne.lat + latBuffer
		) {
			if (
				extremities.sw.lng - lngBuffer <= point.lng &&
				point.lng <= extremities.ne.lng + lngBuffer
			) {
				return true;
			}
		}
		return false;
	};

	getMarkers = () => {
		let newMarkersArray = [];

		// Get all schools "in" polygon
		if (this.props.toggleMarkers.schools) {
			let SCHOOLS = this.state.markersData.SCHOOLS;
			let filteredTypes = Object.entries(this.props.toggleTypes.SCHOOLS)
				.filter(pair => pair[1])
				.map(pair => pair[0]);

			for (var i = 0; i < SCHOOLS.length; i++) {
				let school = SCHOOLS[i];
				if (filteredTypes.includes(school.type)) {
					// Build School Marker
					let schoolMarker = this.makeMarker(
						school.name,
						school.lat,
						school.lng,
						"school",
						<div className={styles.infoWindow}>
							<h5>{school.name}</h5>
							{/* <p>Fraser Institute Rating: {school.rating}</p> */}
							<p>{school.board}</p>
							<p>
								Grades:{" "}
								<a href={school.url} target="_blank">
									{school.type}
								</a>
							</p>
							<p>Address: {school.address}</p>
						</div>
					);
					newMarkersArray = [...newMarkersArray, schoolMarker];
				}
			}
		}

		if (this.props.toggleMarkers.healthcare) {
			let HEALTHCARE = this.state.markersData.HEALTHCARE;
			let filteredTypes = Object.entries(
				this.props.toggleTypes.HEALTHCARE
			)
				.filter(pair => pair[1])
				.map(pair => pair[0]);
			// Get all walkins "in" polygon
			for (let i = 0; i < HEALTHCARE.length; i++) {
				let walkin = HEALTHCARE[i];
				if (filteredTypes.includes(walkin.type)) {
					// Build Walkin Marker
					let walkinMarker = this.makeMarker(
						walkin.name,
						walkin.lat,
						walkin.lng,
						"healthcare",
						<div className={styles.infoWindow}>
							<h5>{walkin.name}</h5>
							<p>Type: {walkin.type}</p>
							<p>Address: {walkin.address}</p>
						</div>
					);
					newMarkersArray = [...newMarkersArray, walkinMarker];
				}
			}
		}

		if (this.props.toggleMarkers.parks) {
			let PARKS = this.state.markersData.PARKS;
			// Get all parks near polygon
			for (let j = 0; j < PARKS.length; j++) {
				if (PARKS[j].geometry) {
					if (PARKS[j].fields) {
						let park = {
							name: PARKS[j].fields.map_label,
							lat: parseFloat(PARKS[j].geometry.coordinates[1]),
							lng: parseFloat(PARKS[j].geometry.coordinates[0]),
							address: PARKS[j].fields.address
						};
						// Build Walkin Marker
						let parkMarker = this.makeMarker(
							park.name,
							park.lat,
							park.lng,
							"park",
							<div className={styles.infoWindow}>
								<h5>{park.name}</h5>
								<p>Address: {park.address}</p>
							</div>
						);
						newMarkersArray = [...newMarkersArray, parkMarker];
					}
				}
			}
		}

		if (this.props.toggleMarkers.grocerystores) {
			let GROCERYSTORES = this.state.markersData.GROCERYSTORES;
			// Get all grocery stores near polygon
			for (let i = 0; i < GROCERYSTORES.length; i++) {
				let store = GROCERYSTORES[i];
				// Build Walkin Marker
				let storeMarker = this.makeMarker(
					store.name,
					store.lat,
					store.lng,
					"store",
					<div className={styles.infoWindow}>
						<h5>{store.name}</h5>
						<p>Address: {store.address}</p>
					</div>
				);
				newMarkersArray = [...newMarkersArray, storeMarker];
			}
		}

		if (this.props.toggleMarkers.libraries) {
			let LIBRARIES = this.state.markersData.LIBRARIES;
			// Get all libraries near polygon
			for (let i = 0; i < LIBRARIES.length; i++) {
				let library = LIBRARIES[i];
				// Build Walkin Marker
				let libraryMarker = this.makeMarker(
					library.name,
					library.lat,
					library.lng,
					"library",
					<div className={styles.infoWindow}>
						<h5>{library.name}</h5>
						<p>Address: {library.address}</p>
					</div>
				);
				newMarkersArray = [...newMarkersArray, libraryMarker];
			}
		}

		if (this.props.toggleMarkers.houses) {
			let HOUSES = this.state.markersData.HOUSES;
			let filteredTypes = Object.entries(this.props.toggleTypes.HOUSES)
				.filter(pair => pair[1])
				.map(pair => pair[0]);
			// Get all houses near polygon
			for (let i = 0; i < HOUSES.length; i++) {
				let house = HOUSES[i];
				if (filteredTypes.includes(house.type)) {
					// Build House Marker
					let houseMarker = this.makeMarker(
						house.address,
						house.lat,
						house.lng,
						"house",
						<div className={styles.infoWindow}>
							<h5>{house.address}</h5>
							<img src={house.img} alt="" />
							<p>
								Price:{" "}
								<a href={house.url} target="_blank">
									{house.price}
								</a>
							</p>
						</div>
					);
					newMarkersArray = [...newMarkersArray, houseMarker];
				}
			}
		}

		if (this.props.toggleMarkers.worship) {
			let WORSHIP = this.state.markersData.WORSHIP;
			// let filteredTypes = Object.entries(this.props.toggleTypes.WORSHIP)
			//   .filter((pair) => pair[1])
			//   .map((pair) => pair[0]);
			// Get all places of worship stores near polygon
			for (let i = 0; i < WORSHIP.length; i++) {
				let church = WORSHIP[i];
				// UNCOMMENT TO FILTER
				// if (filteredTypes.includes(church.type)){
				// Build Walkin Marker
				let churchMarker = this.makeMarker(
					church.name,
					church.lat,
					church.lng,
					"worship",
					<div className={styles.infoWindow}>
						<h5>{church.name}</h5>
						<p>Address: {church.address}</p>
					</div>
				);
				newMarkersArray = [...newMarkersArray, churchMarker];
				// }
			}
		}

		if (this.props.toggleMarkers.restaurants) {
			let RESTAURANTS = this.state.markersData.RESTAURANTS;
			// let filteredTypes = Object.entries(this.props.toggleTypes.RESTAURANTS)
			//   .filter((pair) => pair[1])
			//   .map((pair) => pair[0]);
			// Get all restaurants near polygon
			for (let i = 0; i < RESTAURANTS.length; i++) {
				let restaurant = RESTAURANTS[i];
				// UNCOMMENT TO FILTER
				// if (filteredTypes.includes(restaurant.type)){
				// Build Walkin Marker
				let restaurantMarker = this.makeMarker(
					restaurant.name,
					restaurant.lat,
					restaurant.lng,
					"restaurant",
					<div className={styles.infoWindow}>
						<h5>{restaurant.name}</h5>
						<p>Address: {restaurant.address}</p>
					</div>
				);
				newMarkersArray = [...newMarkersArray, restaurantMarker];
				// }
			}
		}

		if (this.props.toggleMarkers.marinas) {
			let MARINAS = this.state.markersData.MARINAS;
			// Get all marinas stores near polygon
			for (let i = 0; i < MARINAS.length; i++) {
				let marina = MARINAS[i];
				// Build Walkin Marker
				let marinaMarker = this.makeMarker(
					marina.name,
					marina.lat,
					marina.lng,
					"marina",
					<div className={styles.infoWindow}>
						<h5>{marina.name}</h5>
						<p>Address: {marina.address}</p>
					</div>
				);
				newMarkersArray = [...newMarkersArray, marinaMarker];
			}
		}

		if (this.props.toggleMarkers.dogparks) {
			let DOGPARKS = this.state.markersData.DOGPARKS;
			// Get all dogparks stores near polygon
			for (let i = 0; i < DOGPARKS.length; i++) {
				let dogpark = DOGPARKS[i];
				// Build Walkin Marker
				let dogparkMarker = this.makeMarker(
					dogpark.name,
					dogpark.lat,
					dogpark.lng,
					"dogpark",
					<div className={styles.infoWindow}>
						<h5>{dogpark.name}</h5>
						<p>Address: {dogpark.address}</p>
					</div>
				);
				newMarkersArray = [...newMarkersArray, dogparkMarker];
			}
		}
		if (this.props.toggleMarkers.sports) {
			let SPORTS = this.state.markersData.SPORTS;
			let filteredTypes = Object.entries(this.props.toggleTypes.SPORTS)
				.filter(pair => pair[1])
				.map(pair => pair[0]);
			// Get all sports stores near polygon
			for (let i = 0; i < SPORTS.length; i++) {
				let sport = SPORTS[i];
				if (filteredTypes.includes(sport.type)) {
					// Build Walkin Marker
					let sportsMarker = this.makeMarker(
						sport.name,
						sport.lat,
						sport.lng,
						"sport",
						<div className={styles.infoWindow}>
							<h5>{sport.name}</h5>
							<p>Type: {sport.type}</p>
							<p>Address: {sport.address}</p>
						</div>
					);
					newMarkersArray = [...newMarkersArray, sportsMarker];
				}
			}
		}

		if (this.props.toggleMarkers.transit) {
			let BUSSTOPS = this.state.markersData.BUSSTOPS;
			let BUSROUTES = this.state.markersData.BUSROUTES;
			let PARKANDRIDES = this.state.markersData.PARKANDRIDES;
			let filteredTypes = Object.entries(this.props.toggleTypes.TRANSIT)
				.filter(pair => pair[1])
				.map(pair => pair[0]);

			// Get all bus stops
			if (filteredTypes.includes("Bus Stop")) {
				for (let i = 0; i < BUSSTOPS.length; i++) {
					let stop = BUSSTOPS[i];
					let stopMarker = this.makeMarker(
						stop.fields.stop_name,
						stop.fields.stop_coordinates[0],
						stop.fields.stop_coordinates[1],
						"busstop",
						<div className={styles.infoWindow}>
							<h5>{stop.fields.stop_name}</h5>
							<p>Type: Bus Stop</p>
						</div>
					);
					newMarkersArray = [...newMarkersArray, stopMarker];
				}
			}
			// Get all bus routes
			let colours = [
				"#a9ec1f",
				"#dd2324",
				"#6dd2f5",
				"#b02eab",
				"#6cc53d",
				"#a91a4c",
				"#97eb90",
				"#c2224a",
				"#deac00",
				"#d05ae8",
				"#861ab8",
				"#73b5b2",
				"#ce71a8",
				"#21efab",
				"#a17cd2",
				"#d8ec64",
				"#cc6fb7",
				"#ea086e",
				"#d2b78c",
				"#5bb24c",
				"#da2bcd",
				"#2d5c7b",
				"#6d059b"
			];

			if (filteredTypes.includes("Bus Route")) {
				for (let i = 0; i < BUSROUTES.length; i++) {
					let routes = BUSROUTES[i].fields.shape.coordinates;
					for (let j = 0; j < routes.length; j++) {
						let routePath = routes[j].map(pair => {
							return { lng: pair[0], lat: pair[1] };
						});
						let routeColor = colours[i];
						let line = (
							<Polyline
								key={
									routeColor +
									Math.random()
										.toString(36)
										.substring(7)
								}
								path={routePath}
								options={{
									strokeColor: routeColor,
									strokeWeight: 2
								}}
							/>
						);
						newMarkersArray = [...newMarkersArray, line];
					}
				}
			}

			// Get all park and rides
			for (let i = 0; i < PARKANDRIDES.length; i++) {
				let pr = PARKANDRIDES[i];
				if (filteredTypes.includes(pr.type)) {
					let prMarker = this.makeMarker(
						pr.name,
						pr.lat,
						pr.lng,
						"parkandride",
						<div className={styles.infoWindow}>
							<h5>{pr.name}</h5>
							<p>Type: {pr.type}</p>
							<p>Address: {pr.address}</p>
						</div>
					);
					newMarkersArray = [...newMarkersArray, prMarker];
				}
			}
		}

		if (this.props.toggleMarkers.trails) {
			let TRAILS = this.state.markersData.TRAILS;
			let trailmarkerExists = [];
			for (let i = 0; i < TRAILS.length; i++) {
				let trail = TRAILS[i];
				if (!trailmarkerExists.includes(trail.fields.trailname)) {
					let trailMarker = this.makeMarker(
						trail.fields.trailname,
						trail.fields.geo_point_2d["lat"],
						trail.fields.geo_point_2d["lng"],
						"trail",
						<div className={styles.infoWindow}>
							<h5>{trail.fields.trailname}</h5>
						</div>
					);
					trailmarkerExists = [
						...trailmarkerExists,
						trail.fields.trailname
					];
					newMarkersArray = [...newMarkersArray, trailMarker];
				}
			}

			for (let i = 0; i < TRAILS.length; i++) {
				let path = TRAILS[i].fields.geo_shape.coordinates;
				if (TRAILS[i].fields.geo_shape.type === "MultiLineString") {
					for (let j = 0; j < path.length; j++) {
						let newPolyline = (
							<Polyline
								key={Math.random()}
								path={path[j]}
								options={{
									strokeColor: "#006400",
									strokeWeight: 4
								}}
							/>
						);
						newMarkersArray = [...newMarkersArray, newPolyline];
					}
				} else if (TRAILS[i].fields.geo_shape.type === "LineString") {
					let line = [];
					for (let j = 0; j < path.length; j++) {
						line.push(path[j][0]);
					}
					let newPolyline = (
						<Polyline
							key={Math.random()}
							path={line}
							options={{
								strokeColor: "#006400",
								strokeWeight: 4
							}}
						/>
					);
					newMarkersArray = [...newMarkersArray, newPolyline];
				}
			}
		}

		if (this.props.toggleMarkers.transportation) {
			let TRANSPORTATION = this.state.markersData.TRANSPORTATION;
			// Get all modes of transportation
			for (let i = 0; i < TRANSPORTATION.length; i++) {
				let trans = TRANSPORTATION[i];
				// Build Marker
				// name, lat, lng, type, info
				let marker = this.makeMarker(
					trans.name,
					trans.lat,
					trans.lng,
					trans.type,
					<div className={styles.infoWindow}>
						<h5>{trans.name}</h5>
						<p>
							Address:{" "}
							<a href={trans.url} target="_blank">
								{trans.address}
							</a>
						</p>
					</div>
				);
				newMarkersArray = [...newMarkersArray, marker];
			}
		}

		if (this.props.toggleMarkers.entertainment) {
			let ENTERTAINMENT = this.state.markersData.ENTERTAINMENT;
			let filteredTypes = Object.entries(
				this.props.toggleTypes.ENTERTAINMENT
			)
				.filter(pair => pair[1])
				.map(pair => pair[0]);
			// Get all modes of transportation
			for (let i = 0; i < ENTERTAINMENT.length; i++) {
				let ent = ENTERTAINMENT[i];
				if (filteredTypes.includes(ent.type)) {
					// Build Marker
					// name, lat, lng, type, info
					let marker = this.makeMarker(
						ent.name,
						ent.lat,
						ent.lng,
						"entertainment",
						<div className={styles.infoWindow}>
							<h5>{ent.name}</h5>
							<p>Type: {ent.type}</p>
							<p>Address: {ent.address}</p>
						</div>
					);
					newMarkersArray = [...newMarkersArray, marker];
				}
			}
		}

		if (this.props.toggleMarkers.childcare) {
			let CHILDCARE = this.state.markersData.CHILDCARE;
			// Get all modes of transportation
			for (let i = 0; i < CHILDCARE.length; i++) {
				let care = CHILDCARE[i];
				// Build Marker
				// name, lat, lng, type, info
				let marker = this.makeMarker(
					care.name,
					care.lat,
					care.lng,
					"childcare",
					<div className={styles.infoWindow}>
						<h5>{care.name}</h5>
						<p>Address: {care.address}</p>
					</div>
				);
				newMarkersArray = [...newMarkersArray, marker];
			}
		}

		if (this.props.toggleMarkers.culture) {
			let CULTURE = this.state.markersData.CULTURE;
			// Get all modes of transportation
			for (let i = 0; i < CULTURE.length; i++) {
				let cult = CULTURE[i];
				// Build Marker
				// name, lat, lng, type, info
				let marker = this.makeMarker(
					cult.name,
					cult.lat,
					cult.lng,
					"culture",
					<div className={styles.infoWindow}>
						<h5>{cult.name}</h5>
						<p>
							Address:{" "}
							<a href={cult.url} target="_blank">
								{cult.address}
							</a>
						</p>
					</div>
				);
				newMarkersArray = [...newMarkersArray, marker];
			}
		}

		// Get markers from search string
		if (this.props.search_box_result !== undefined) {
			let search = this.props.search_box_result;
			let searchMarker = this.makeMarker(
				search.name,
				search.lat,
				search.lng,
				"search",
				<div className={styles.infoWindow}>
					<h5>{search.name}</h5>
					<p>Address: {search.address}</p>
				</div>
			);
			newMarkersArray = [...newMarkersArray, searchMarker];
		}

		// Return new markers array
		this.setState({
			markersArray: newMarkersArray,
			infoWindow: undefined
		});

		// return promise
		return Promise.resolve(1);
	};

	componentDidUpdate(prevProps, prevState) {
		if (
			prevProps.polygon_coordinates !== this.props.polygon_coordinates ||
			prevProps.toggleMarkers !== this.props.toggleMarkers ||
			prevProps.toggleTypes !== this.props.toggleTypes ||
			prevProps.search_box_result !== this.props.search_box_result
		) {
			setTimeout(() => {
				this.getMarkers();
			}, 200);
		}
	}

	componentWillUnmount() {
		this.props.setTogglesExternal([]);
	}

	render() {
		return (
			<div style={{ height: "100%", position: "relative" }}>
				<MapComponent
					house={this.props.house}
					work={this.props.work}
					markersArray={this.state.markersArray}
					infoWindow={this.state.infoWindow}
					closeInfoWindow={this.closeInfoWindow}
					getCoordinates={this.props.getCoordinates}
					getExtremities={this.getExtremities}
					polygon_coordinates={this.props.polygon_coordinates}
					selected_neighbourhood={this.props.selected_neighbourhood}
				/>

				{this.props.display_map && (
					<div>
						<ToggleTypesBox
							toggleMarkers={this.props.toggleMarkers}
							types={this.state.types}
							getMarkers={this.getMarkers}
						/>
						<div
							style={{
								bottom: "10px",
								position: "absolute",
								width: "100%",
								display: "flex",
								justifyContent: "center",
								pointerEvents: "none"
							}}
						>
							{/*!this.state.loading && <ToggleBox />*/}
							<ToggleBox loading={this.state.loading} />
							{/*
              this.state.loading && <div className={styles.loader}> <Loader /> </div>
            */}
						</div>
						{window.google && <SearchBox />}
						<NeighbourhoodName />
						<Info />
					</div>
				)}
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		// loading: state.map.loading,
		search_box_result: state.nav.search_box_result,
		externalToggles: state.survey.externalToggles,
		toggleMarkers: state.map.toggleMarkers,
		toggleTypes: state.map.toggleTypes,
		selected_neighbourhood: state.nav.selected_neighbourhood,
		selected_neighbourhood_name: state.nav.selected_neighbourhood_name,
		polygon_coordinates: state.nav.polygon_coordinates,
		polygon_center: state.nav.polygon_center,
		display_map: state.nav.display_map
	};
}

const actions = {
	toggleMarker,
	setTogglesExternal
};

export default connect(
	mapStateToProps,
	actions
)(MapBox);



// WEBPACK FOOTER //
// ./src/components/pages/Map/MapBox/MapBox.js